import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'select',
    standalone: false
})
export class SelectPipe implements PipeTransform {
    transform(input: object, property: string): any {
        if (!input) {
            return input;
        }

        return input[property];
    }
}
